import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import {
    BetmgmOriginalsService,
    CasinoLobbyService,
    CasinoManager,
    ConfigProviderService,
    GameManagerService,
    JackpotAndPromotionsService,
    PromoOptinStatusType,
} from '@casinocore/platform/core';
import { UserService } from '@frontend/vanilla/core';
import { rxEffects } from '@rx-angular/state/effects';

import { CasinoCoreLazyPlaceholderComponent } from '../casino-core-lazy-placeholder/casino-core-lazy-placeholder.component';
import { LMTCategoryLobbyComponent } from '../lmt-category-lobby/lmt-category-lobby.component';

@Component({
    selector: 'cc-lmt-category-wrapper',
    templateUrl: 'lmt-category-wrapper.component.html',
    standalone: true,
    imports: [NgSwitch, NgIf, NgSwitchCase, CasinoCoreLazyPlaceholderComponent, NgSwitchDefault, LMTCategoryLobbyComponent],
})
export class LMTCategoryWrapperComponent implements OnChanges {
    @Input() categoryId: string;
    @Input() isTouch: boolean;
    @Input() category: any;
    @Input() lobbyType: string;
    @Input() gameContainer: string;
    liveGameIframeCategory: string;
    liveGameInfo: any;
    liveGamesCategory: any;
    discoverFeedLmtkey: boolean;
    isSlotRacesEnabled: boolean;
    slotRacesCategoryId: string;
    isSlotRacesPhase2Enabled: boolean;
    //jackpotTileCategory: string;
    private readonly rxEffects = rxEffects();
    jackpotGroupId: any;
    displayBetMGMOriginals: boolean;
    constructor(
        private casinoManager: CasinoManager,
        private configProviderService: ConfigProviderService,
        private casinoLobbyService: CasinoLobbyService,
        private betmgmoriginalservice: BetmgmOriginalsService,
        private user: UserService,
        private jackpotAndPromotionsService: JackpotAndPromotionsService,
        private gameManagerService: GameManagerService,
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.lobbyType || changes.categoryId) {
            this.getInputParameters();
        }
    }
    getInputParameters() {
        const jackpotconfig = this.configProviderService.provideJackpotConfig();
        if (jackpotconfig.enableJackpotTile) {
            this.rxEffects.register(this.jackpotAndPromotionsService.jackpotGroupObservable, (jackpotGroupId: string) => {
                this.jackpotGroupId = jackpotGroupId;
            });
        }
        const features = this.configProviderService.provideFeaturesConfig();
        let slotRacesConfig = this.configProviderService.provideSlotRacesConfig();
        this.isSlotRacesPhase2Enabled = slotRacesConfig?.enableSlotRacesPhase2;
        this.isSlotRacesEnabled = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, features.enableSlotRacesForLobbyType);
        this.slotRacesCategoryId = this.casinoManager.getSlotRaceCategoryId(this.lobbyType);
        const discoverFeedConfig = this.configProviderService.provideDiscoverFeedConfig();
        if (discoverFeedConfig.enableDiscoverFeed) {
            this.discoverFeedLmtkey = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, discoverFeedConfig.discoverFeedLmtkey);
        }
        const casinoConfig = this.configProviderService.provideCasinoConfig();
        if (casinoConfig.enableLiveGames) this.checkLiveGameIframeCategory();
        this.loadBetMgmOriginals();
    }

    checkLiveGameIframeCategory() {
        const casinoConfig = this.configProviderService.provideCasinoConfig();
        if (casinoConfig.liveGamesCategories && casinoConfig.liveGamesCategories.length > 0) {
            for (let i = 0; i < casinoConfig.liveGamesCategories.length; i++) {
                if (casinoConfig?.liveGamesCategories[i]?.toLowerCase() === this.categoryId?.toLowerCase()) {
                    const liveCategoryInfo = this.casinoLobbyService.getCategoryInfo(this.lobbyType, this.categoryId);
                    this.liveGameInfo = this.gameManagerService.getGameInfo(liveCategoryInfo.categoryInfo.gamelist[0].game);
                    this.liveGamesCategory = liveCategoryInfo.categoryInfo;
                    if (this.liveGameInfo) {
                        this.liveGameIframeCategory = this.categoryId;
                    }
                }
            }
        }
    }

    loadBetMgmOriginals(): void {
        const betMGMOriginalsConfig: any = this.configProviderService.providerBetMGMOriginalsConfig();
        const displayBetmgmOriginals = this.casinoLobbyService.getCategoryInfo(this.lobbyType, this.categoryId)?.categoryInfo.sitecoreData
            ?.displayBetMGMOriginals;
        if (this.betmgmoriginalservice.validateBetMgmOriginalsConfigs(displayBetmgmOriginals, betMGMOriginalsConfig, this.user.isAuthenticated)) {
            this.betmgmoriginalservice.betMgmOriginalsTimerObservable.subscribe((isTimerRunning: boolean) => {
                this.setDisplayBetMGMOriginals(isTimerRunning);
            });
            this.betmgmoriginalservice.getOptInObservable.subscribe((response: any) => {
                this.setDisplayBetMGMOriginals(
                    response &&
                        (response.status.toUpperCase() == PromoOptinStatusType.OptedIn ||
                            response.status.toUpperCase() == PromoOptinStatusType.Offered),
                );
            });
            this.betmgmoriginalservice.getBetmgmOriginalsUserStatus(
                betMGMOriginalsConfig.betmgmOriginalsConfigurations.SourceType,
                betMGMOriginalsConfig.betmgmOriginalsConfigurations.SourceId,
            );
        } else {
            this.setDisplayBetMGMOriginals(false);
        }
    }

    private setDisplayBetMGMOriginals(displayBetMGMOriginals: boolean): void {
        this.displayBetMGMOriginals = displayBetMGMOriginals ? true : false;
    }
}
